module.exports = __webpack_public_path__ + "assets/img/hotel.d2d33f0d.png";